import React, { useEffect, useState } from "react";
import api from "@/api";
import { Shield, Building2, Users, FileText, Database } from "lucide-react";
import { Link } from "react-router-dom";

const StatCard = ({ icon: Icon, label, value, to, testId }) => (
  <Link to={to} data-testid={testId} className="bg-white border border-slate-200 rounded-lg p-5 hover:-translate-y-0.5 hover:shadow-sm transition-all block">
    <div className="flex items-center justify-between mb-3">
      <div className="w-9 h-9 rounded-md bg-[#E5F0F2] flex items-center justify-center text-[#006080]">
        <Icon size={16} />
      </div>
    </div>
    <p className="text-2xl font-bold text-slate-900">{value ?? "—"}</p>
    <p className="text-xs font-bold uppercase tracking-wide text-slate-500 mt-1">{label}</p>
  </Link>
);

export default function AdminDashboard() {
  const [stats, setStats] = useState({});

  useEffect(() => {
    api.get("/admin/stats").then(r => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-md bg-[#E5F0F2] flex items-center justify-center text-[#006080]">
          <Shield size={16} />
        </div>
        <div>
          <h2 className="text-xl font-bold text-slate-900">Super Admin</h2>
          <p className="text-sm text-slate-500">Platform-wide management and configuration.</p>
        </div>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard icon={Building2} label="Companies" value={stats.companies} to="/admin/companies" testId="stat-companies" />
        <StatCard icon={Users} label="Users" value={stats.users} to="/admin/users" testId="stat-users" />
        <StatCard icon={FileText} label="Documents" value={stats.documents} to="/documents" testId="stat-docs" />
        <StatCard icon={Database} label="Schemas" value={stats.schemas} to="/schemas" testId="stat-schemas-admin" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {[
          { to: "/admin/companies", icon: Building2, title: "Manage Companies", desc: "Create, edit, archive companies and manage their credits." },
          { to: "/admin/users", icon: Users, title: "Manage Users", desc: "Create company admins and users, set roles and permissions." },
          { to: "/admin/config", icon: Shield, title: "Platform Config", desc: "Set global Mistral API key, billing toggles, and system settings." },
        ].map(item => (
          <Link key={item.to} to={item.to} data-testid={`admin-card-${item.title.toLowerCase().replace(/\s+/g, "-")}`} className="bg-white border border-slate-200 rounded-lg p-5 hover:-translate-y-0.5 hover:shadow-sm transition-all">
            <div className="w-8 h-8 rounded-md bg-[#E5F0F2] flex items-center justify-center text-[#006080] mb-3">
              <item.icon size={15} />
            </div>
            <h3 className="text-sm font-semibold text-slate-900 mb-1">{item.title}</h3>
            <p className="text-xs text-slate-500">{item.desc}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
